import React from 'react';
import get from 'lodash/get';
import { compose } from 'redux';
import HotDeals from '../../../components/HotDeals/HotDeals';
import withReducerSaga from '../../../hoc/ReducerRegistry/withReducerSaga';
import ProductCartridgeReducer from '../../../reducers/ProductCartridgeReducer';
import watchProductListForRecommendation, {
    watchResetProductList,
} from '../../../sagas/ProductCartridgeSaga';

export const massageProps = (props, preferences) => {
    let massagedData = {};
    const massagedDataWrapper = {};
    /* istanbul ignore else */
    if (props) {
        const recordInfo = [];
        /* istanbul ignore next */
        if (props.productGrid && props.productGrid.items && props.productGrid.items.length > 0) {
            const itemsArr = props.productGrid.items;
            itemsArr.forEach((value) => {
                let itemObj = {};
                /* istanbul ignore next */
                const {
                    id,
                    name = '',
                    ppUrl: url = '',
                    analyticsTag = '',
                    valuation = {},
                    images = [],
                    pricing: { root = {} } = {},
                    enableMiniPDP = false,
                } = value;
                const {
                    rating: averageRating,
                    reviews: { count: reviewCount = '' } = {},
                } = valuation;
                const { amounts = [], promotions } = root;
                const { marketingLabel = null } = root;
                const { manufacturerAdvertised = false, priceLabel: eachLabel = '' } = root;
                const mapPrice = manufacturerAdvertised.toString();
                const [arrayObj = []] = images;
                const { url: imageId = '' } = arrayObj;
                const { altText: altImageId = '' } = arrayObj;
                let filterOriginalMax = {};
                let filterCurrentMax = {};
                const ppId = id;
                /* istanbul ignore else */
                if (amounts) {
                    filterOriginalMax =
                        amounts.find((val) => val.type.toLowerCase() === 'original') || {};
                    filterCurrentMax =
                        amounts.find((val) => val.type.toLowerCase() !== 'original') || {};
                }
                const { type: currentPriceType = 'DEFAULT' } = filterCurrentMax;
                const { max: originalMax } = filterOriginalMax;
                const { min: originalMin } = filterOriginalMax;
                const { max: currentMax } = filterCurrentMax;
                const { min: currentMin } = filterCurrentMax;
                const currentPriceLabel = currentPriceType.toLowerCase();
                const coupon = get(root, 'couponInfo[0]');
                const couponPrice = {};
                const { disableFPACAPI, disableFPAC } = get(preferences, 'fpac.hotDeal', {});
                // this is to get eligabilityMesage from eligibleCouponInfo
                const eligibleCouponInfo = get(root, 'eligibleCouponInfo[0]');
                let eligibilityMessage = '';
                /* istanbul ignore next */
                if (coupon && !disableFPACAPI && !disableFPAC) {
                    const fpac = {
                        fpacPriceMax: get(coupon, 'amount.max'),
                        fpacPriceMin: get(coupon, 'amount.min'),
                        fpacCoupon: get(coupon, 'alphaId'),
                    };
                    couponPrice.fpac = fpac;
                } else if (eligibleCouponInfo && !disableFPACAPI && !disableFPAC) {
                    const fpac = {
                        fpacPriceMax: get(eligibleCouponInfo, 'amount.max'),
                        fpacPriceMin: get(eligibleCouponInfo, 'amount.min'),
                        fpacCoupon: get(eligibleCouponInfo, 'alphaId'),
                    };
                    couponPrice.fpac = fpac;
                    eligibilityMessage = get(eligibleCouponInfo, 'eligibilityMessage');
                }

                itemObj = {
                    name,
                    url,
                    mapPrice,
                    marketingLabel,
                    eligibilityMessage,
                    ppId,
                    imageId,
                    altImageId,
                    averageRating,
                    reviewCount,
                    originalMax,
                    originalMin,
                    currentMax,
                    currentMin,
                    currentPriceLabel,
                    enableMiniPDP,
                    analyticsTag,
                    promotions,
                    eachLabel,
                    ...couponPrice,
                };

                recordInfo.push(itemObj);
            });
        }

        const certonaStrategy = props.strategy || '';
        const certonaEnabled = !!props.strategy;
        /* istanbul ignore next */
        const {
            bgColor: backGroundColor = '',
            textColor: marketingTagLineColor,
            buttonText: buttonStyle = '',
            image: { url: imagePath = '' } = {},
            buttonText: shopAllTitle,
            link: { url: seoUrl = '' } = {},
            openInNewTab,
            headline: marketingHeadLine,
            subheadline: marketingTagLine,
            strategy: type = 'HotDeals',
        } = props;
        massagedData = {
            backGroundColor,
            marketingTagLineColor,
            buttonStyle,
            imagePath,
            shopAllTitle,
            seoUrl,
            openInNewTab,
            certonaStrategy,
            certonaEnabled,
            marketingHeadLine,
            marketingTagLine,
            type,
        };
        massagedData.recordsInfoList = recordInfo;
        massagedData.type = props.strategy || 'HotDeals';
        massagedDataWrapper[massagedData.type] = massagedData;
    }
    return massagedDataWrapper;
};

const HotDealsIrisWrapper = (props) => {
    const { strategy, pageType, deviceType, preferences, automationId } = props;
    return (
        <HotDeals
            pageType={pageType}
            deviceType={deviceType}
            automationId={
                /* istanbul ignore next */
                automationId || `hotdeals-${strategy}` || 'automation-hotdeals-strategy'
            }
            slotId={strategy || 'HotDeals'}
            attributes={{
                contentrecommendations: false,
                recommendations: true,
                schemes: strategy || '',
            }}
            hotDealsCartridgeSlots={massageProps(props, preferences)}
            featureFlags={{ UrgencyMessageEnabled: true }}
        />
    );
};

export default compose(
    withReducerSaga(
        [ProductCartridgeReducer],
        [watchProductListForRecommendation, watchResetProductList]
    )
)(HotDealsIrisWrapper);
